import dayjs from 'dayjs';

export const isLessThan36Months = (startDate: string, format?: string, strict?: boolean) => {
  const now = dayjs();
  const start = dayjs(startDate, format, strict);
  return now.diff(start, 'month') < 36;
};
